import { useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { AuthModalState } from '@/types/auth-types';

interface UseSyncedAuthModalStateInput {
  initialState: AuthModalState;
}

export interface SyncedAuthModalState {
  modalState: AuthModalState;
  setModalState: Dispatch<SetStateAction<AuthModalState>>;
}

export function useSyncedAuthModalState({
  initialState,
}: UseSyncedAuthModalStateInput): SyncedAuthModalState {
  const [syncedInitialState, setSyncedInitialState] = useState<AuthModalState>(initialState);
  const [modalState, setModalState] = useState<AuthModalState>(initialState);

  if (syncedInitialState !== initialState) {
    setSyncedInitialState(initialState);
    setModalState(initialState);
  }

  return {
    modalState,
    setModalState,
  };
}
